import React from 'react';
import { createAccountControlsDesktopLayoutClassName } from './accountControlsDesktopLayoutStyles';

type LayoutProps = {
  email: React.ReactNode;
  action: React.ReactNode;
};

export const AccountControlsDesktopLayoutComponent = (props: LayoutProps) => {
  const { email, action } = props;

  return (
    <div className={createAccountControlsDesktopLayoutClassName('wrapper')}>
      <div className={createAccountControlsDesktopLayoutClassName('emailSlot')}>
        {email}
      </div>
      <div
        className={createAccountControlsDesktopLayoutClassName('actionSlot')}
      >
        {action}
      </div>
    </div>
  );
};
